const axios = require('axios');

async function getPurchaseServices(condition) {
  try {
    const resData = await axios.get('/api/v1/admin/pservice/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findPurchaseServiceById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/pservice', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updatePaymentService(params) {
  try {
    const resData = await axios.put('/api/v1/admin/pservice', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function creatNewPaymentService(params) {
  try {
    const resData = await axios.post('/api/v1/admin/pservice', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getPurchaseServices, findPurchaseServiceById, updatePaymentService, creatNewPaymentService };
